<template>
  <a-row class="container-fluid container-wrap col-sm-12 col-xs-12">
    <a-col :span="1"></a-col>
    <a-col class="justify-content-center" :span="22">
      <div style="margin-top: 28px"></div>
      <div class="card-header pb-0 col-sm-12 d-flex">
        <div class="col-sm-12 col-xs-12">
          <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
            <h3 class="title">{{ $t('navbar_contract_goal_management') }}</h3>
            <h5 class="desc">물품 공급 계약, 장비 계약 등 각종 계약의 목표실적을 관리 할 수 있습니다.</h5>
          </div>
        </div>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <a-row justify="space-between">
          <a-typography-title :level="4">
            <a-select 
              v-model:value="selectedYear" 
              style="width: 100px; margin-right: 8px;"
              size="small"
              @change="handleYearChange"
            >
              <a-select-option 
                v-for="year in yearOptions" 
                :key="year" 
                :value="year"
              >
                {{ year }}년
              </a-select-option>
            </a-select>
            목표-실적
            <a-tooltip  trigger="click">
              <template #title>설치확인서와 계약 상태중 서명 중단됨을 제외한 데이터에 대해서 집계합니다.</template>
              <i class="fa-regular fa-info-circle" />
            </a-tooltip>
          </a-typography-title>
          <a-button 
            @click="uiHandler.reloadPage" 
            size="small"
          >
            <template #icon >
              <i class="fa-regular fa-rotate-right" />
            </template>
          </a-button>
        </a-row>
        <a-row justify="start" style="gap: 16px; margin-bottom: 20px">
          <a-col class="card content-wrap-card">
            <a-tooltip>
              <template #title>{{ this.dashboard.totalGoalAmount.toLocaleString() + "원" }}</template>
              <a-statistic
                  title="연간목표금액"
                  :value="totalGoalAmountTxt"
                  :value-style="{ color: '#232323' }"
                  style="margin-right: 50px"
              >
                <template #prefix>
                  <i class="fa-regular fa-won-sign"/>
                </template>
              </a-statistic>
            </a-tooltip>
          </a-col>
          <a-col class="card content-wrap-card">
            <a-statistic
                :value=" dashboard.cumulativeAccomplishRate"
                suffix="%"
                :value-style="{ color: '#232323' }"
                style="margin-right: 50px"
            >
              <template #title>
                <span style="margin-right: 3px;">연간누적달성률</span>
                <a-tooltip  trigger="click">
                  <template #title>연간 계약실적 합계 / 연간 목표금액 합계</template>
                  <i class="fa-regular fa-info-circle" />
                </a-tooltip>
              </template>
              <template #prefix>
                <i class="fa-regular fa-bullseye-arrow"/>
              </template>
            </a-statistic>
          </a-col>
          <a-col class="card content-wrap-card">
            <a-statistic
                title="연간누적계약수"
                :value="dashboard.cumulativeAccomplishCount"
                suffix="건"
                :value-style="{ color: '#232323' }"
                style="margin-right: 50px"
            >
              <template #prefix>
                <i class="fa-regular fa-pen-to-square"/>
              </template>
            </a-statistic>
          </a-col>
          <a-col class="card content-wrap-card">
            <a-tooltip>
              <template #title>{{ this.dashboard.cumulativeAccomplishAmount.toLocaleString() + "원" }}</template>
              <a-statistic
                  title="연간누적계약금액"
                  :value="cumulativeAccomplishAmount"
                  :value-style="{ color: '#232323' }"
                  style="margin-right: 50px"
              >
                <template #prefix>
                  <i class="fa-regular fa-won-sign"/>
                </template>
              </a-statistic>
            </a-tooltip>
          </a-col>
          <a-col class="card content-wrap-card">
            <a-statistic
                :value="dashboard.thisMonthAccomplishRate"
                suffix="%"
                :value-style="{ color: '#232323' }"
                style="margin-right: 50px"
            >

              <template #title>
                <span style="margin-right: 3px;">당월달성률</span>
                <a-tooltip  trigger="click">
                  <template #title>당월 계약실적 합계 / 당월 목표금액</template>
                  <i class="fa-regular fa-info-circle" />
                </a-tooltip>
              </template>
              <template #prefix>
                <i class="fa-regular fa-bullseye-arrow"/>
              </template>
            </a-statistic>
          </a-col>
          <a-col class="card content-wrap-card">
            <a-statistic
                title="당월계약수"
                :value="dashboard.thisMonthAccomplishCount"
                suffix="건"
                :value-style="{ color: '#232323' }"
                style="margin-right: 50px"
            >
              <template #prefix>
                <i class="fa-regular fa-pen-to-square"/>
              </template>
            </a-statistic>
          </a-col>
          <a-col class="card content-wrap-card">
            <a-tooltip>
              <template #title>{{ this.dashboard.thisMonthAccomplishAmount.toLocaleString() + "원" }}</template>
              <a-statistic
                  title="당월계약금액"
                  :value="thisMonthAccomplishAmount"
                  :value-style="{ color: '#232323' }"
                  style="margin-right: 50px"
              >
                <template #prefix>
                  <i class="fa-regular fa-won-sign"/>
                </template>
              </a-statistic>
            </a-tooltip>
          </a-col>
          <a-col class="card content-wrap-card">
            <a-statistic
                :value="dashboard.avgSalesContractDiscountRate"
                :value-style="{ color: '#232323' }"
                style="margin-right: 50px"
                suffix="%"
            >
              <template #title>
                <span style="margin-right: 3px;">물품매매평균할인율</span>
                <a-tooltip  trigger="click">
                  <template #title>장비계약중 물품매매계약서의 평균할인율</template>
                  <i class="fa-regular fa-info-circle" />
                </a-tooltip>
              </template>
              <template #prefix>
                <i class="fa-regular fa-tag"/>
              </template>
            </a-statistic>
          </a-col>
        </a-row>
        <a-row justify="end" style="margin-bottom: 10px">
          <a-col>
            <a-button    type="primary"
                      @click="(e) => modal.settingGoal.show = true"
            >목표관리
            </a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="card content-wrap-card" :span="24">
            <div class="section-title-container">
              <a-typography-title :level="4">월별목표-실적관리</a-typography-title>
            </div>
            <a-row type="flex" :gutter="16" style="height: 300px;">
              <Bar :data="dashboard.chart.월별실적.data" :options="dashboard.chart.월별실적.option"/>
            </a-row>
          </a-col>
        </a-row>
        <a-row justify="space-between" style="margin-bottom: 30px">
          <a-col class="card content-wrap-card" :span="12" style="margin-right: 16px;">
            <div class="section-title-container">
              <a-typography-title :level="4">품목별매출</a-typography-title>
            </div>
            <a-row type="flex" :gutter="16">
              <Pie :data="dashboard.chart.품목별매출.data" :options="dashboard.chart.품목별매출.option"/>
            </a-row>
          </a-col>
          <a-col class="card content-wrap-card" :span="12">
            <div class="section-title-container">
              <a-typography-title :level="4">장비매출</a-typography-title>
            </div>
            <a-row type="flex" :gutter="16" style="height: 100%">
              <Bar :data="dashboard.chart.장비매출.data" :options="dashboard.chart.장비매출.option"/>
            </a-row>
          </a-col>
        </a-row>
        <a-divider></a-divider>
        <a-row justify="end" style="margin-bottom: 10px">
          <a-col>
            <a-config-provider :locale="locale">
              <span style="margin-right: 5px;">*계약일 기준 집계 데이터 입니다.</span>
              <a-range-picker :locale="locale" v-model:value="dateRanges" @change="uiHandler.handleRangePicker"
              :allowClear="false"
                              style="width: 250px; margin-bottom: 10px"/>
            </a-config-provider>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="card content-wrap-card" :span="24">
            <div class="section-title-container">
              <a-typography-title :level="4">일별계약추이</a-typography-title>
            </div>
            <div style="height: 300px;">
              <Bar :data="dashboard.chart.일별실적.data" :options="dashboard.chart.일별실적.option"/>
            </div>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="card content-wrap-card" :span="24">
            <div class="section-title-container">
              <a-typography-title :level="4">지점별계약추이</a-typography-title>
            </div>
            <a-row type="flex" :gutter="16" style="height: 300px;">
              <Bar :data="dashboard.chart.지점별실적.data" :options="dashboard.chart.지점별실적.option"/>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </a-col>
    <a-col :span="1"></a-col>
  </a-row>

  <setting-goal-modal :show-modal="modal.settingGoal.show"
                      @close-modal="uiHandler.handleModal.settingGoal.close"/>
</template>
<style scoped>
@import './goal-management.scss';
</style>
<script>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import SettingGoalModal from "@/views/GoalSettings/SettingGoalModal.vue";
import {Bar, Pie} from 'vue-chartjs'
import {월별실적, 품목별매출, 장비매출, 일별실적, 지점별실적} from './chartConfig';
import contractApi from "@/views/ContractManagement/api";
import {formatCommaNumber, logging} from "@/utils/utils";
import dayjs from "dayjs";
import 'dayjs/locale/ko';
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

export default {
  components: {
    SettingGoalModal,
    Bar, Pie,
  },
  computed: {
    totalGoalAmountTxt() {
      return (this.dashboard.totalGoalAmount / 100000000).toFixed(2) + " 억원"
    },
    cumulativeAccomplishAmount() {
      return (this.dashboard.cumulativeAccomplishAmount / 100000000).toFixed(2) + " 억원"
    },
    thisMonthAccomplishAmount() {
      return (this.dashboard.thisMonthAccomplishAmount / 100000000).toFixed(2) + " 억원"
    }
  },
  mounted() {
    this.uiHandler.getDashboardData()
  },
  data() {
    const page = this
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      locale,
      dateRanges: [dayjs().startOf('month'), dayjs()],
      totalGoalAmount: 0,
      goals: [],
      modal: {
        settingGoal: {
          show: false
        }
      },
      dashboard: {
        totalGoalAmount: 0,
        cumulativeAccomplishAmount: 0,
        cumulativeAccomplishCount: 0,
        cumulativeAccomplishRate: 0,
        thisMonthAccomplishAmount: 0,
        thisMonthAccomplishCount: 0,
        thisMonthAccomplishRate: 0,
        avgSalesContractDiscountRate: 0,
        chart: {
          월별실적: {data: 월별실적.data,
            option: {
              ...월별실적.options,
              onClick: function (evt, element, chart) {
                if (element.length > 0) {
                  const firstPoint = element[0];
                  const label = this.data.labels[firstPoint.index];
                  page.$router.push('/contract/list?status=유효실적&monthDate='+label.replace("월",""));
                }
              }
            }
          },
          품목별매출: {
            data: 품목별매출.data,
            option: {
              ...품목별매출.options,
              onClick: function (evt, element, chart) {
                console.log('ele', this.data)
                if (element.length > 0) {
                  const firstPoint = element[0];
                  const label = this.data.labels[firstPoint.index];
                  const value = this.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
                  console.log(`Clicked element: ${label} - Value: ${value}`);

                  if (label === 'Implant') {
                    page.$router.push('/contract/list?status=유효실적&contractGroup=물품매매');
                  } else {
                    page.$router.push('/contract/list?status=유효실적&contractGroup=장비');
                  }
                }
              }
            }
          },
          장비매출: {
            data: 장비매출.data,
            option: {
              ...장비매출.options, onClick: function (evt, element, chart) {
                const componentIdx = element[0]?.datasetIndex
                const thisData = this.data.datasets[componentIdx]
                if (element.length > 0) {
                  const firstPoint = element[0];
                  const label = thisData.label
                  const value = this.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
                  console.log(`Clicked element: ${label} - Value: ${value}`);

                  if (label.includes('Unit')) {
                    page.$router.push('/contract/list?status=유효실적&contractGroup=UnitChair');
                  } else if (label.includes('CAD')) {
                    page.$router.push('/contract/list?status=유효실적&contractGroup=CADCAM');
                  } else if (label.includes('로봇')) {
                    page.$router.push('/contract/list?status=유효실적&contractGroup=서비스로봇');
                  } else if (label.includes('CT')) {
                    page.$router.push('/contract/list?status=유효실적&contractGroup=CT매매');
                  }
                }
              }
            }
          },
          일별실적: {data: 일별실적.data, option:
            {
              ...일별실적.options,
              onClick: function (evt, element, chart) {
                if (element.length > 0) {
                  const firstPoint = element[0];
                  const label = this.data.labels[firstPoint.index];
                  page.$router.push('/contract/list?status=유효실적&dayDate='+label);
                }
              }
            }
          },
          지점별실적: {data: 지점별실적.data,
            option:  {
              ...지점별실적.options,
              onClick: function (evt, element, chart) {
                if (element.length > 0) {
                  const firstPoint = element[0];
                  const label = this.data.labels[firstPoint.index];
                  page.$router.push('/contract/list?status=유효실적&branch='+label);
                }
              }
            }
          },
        }
      },
      selectedYear: "2025",
      yearOptions: ["2024", "2025"],
    }
  },
  methods: {
    formatCommaNumber,
    ui() {
      return {
        reloadPage:()=>{
          this.uiHandler.getDashboardData()
        },
        handleModal: {
          settingGoal: {
            close: (childPassParam) => {
              this.modal.settingGoal.show = childPassParam.ModalStatus
              this.uiHandler.getDashboardData()
            }
          }
        },
        handleRangePicker: v => {
          this.dateRanges = v
          this.uiHandler.getDashboardData()
        },
        getDashboardData: () => {
          const dateFormat = 'YYYY-MM-DD'
          return this.apiHandler.dashboard({
                startDate: this.dateRanges[0].format(dateFormat),
                endDate: this.dateRanges[1].format(dateFormat),
                year: this.selectedYear
              },
              (response) => {
                this.dashboard.totalGoalAmount = response.data.monthlyGoalPerformanceComparison ? response.data.monthlyGoalPerformanceComparison.goalAmountDatas.reduce((t, c) => t + c, 0) : 0;
                this.dashboard.cumulativeAccomplishAmount = response.data.cumulativeAccomplishAmount ? response.data.cumulativeAccomplishAmount : 0;
                this.dashboard.cumulativeAccomplishCount = response.data.cumulativeAccomplishCount ? response.data.cumulativeAccomplishCount : 0;
                this.dashboard.cumulativeAccomplishRate = response.data.cumulativeAccomplishRate ? response.data.cumulativeAccomplishRate : 0;
                this.dashboard.thisMonthAccomplishAmount = response.data.thisMonthAccomplishAmount ? response.data.thisMonthAccomplishAmount : 0;
                this.dashboard.thisMonthAccomplishCount = response.data.thisMonthAccomplishCount ? response.data.thisMonthAccomplishCount : 0;
                this.dashboard.thisMonthAccomplishRate = response.data.thisMonthAccomplishRate ? response.data.thisMonthAccomplishRate : 0;
                this.dashboard.avgSalesContractDiscountRate = response.data.avgSalesContractDiscountRate ? response.data.avgSalesContractDiscountRate.toFixed(2) : 0;
                this.dashboard.chart.월별실적.data = {
                  ...월별실적.data,
                  datasets: [
                    {
                      ...월별실적.data.datasets[0],
                      data: response.data.monthlyGoalPerformanceComparison.contractAmountDatas
                    },
                    {...월별실적.data.datasets[1], data: response.data.monthlyGoalPerformanceComparison.goalAmountDatas}
                  ],
                  labels: response.data.monthlyGoalPerformanceComparison.labels.map(i => i + "월")
                }
                this.dashboard.chart.품목별매출.data = {
                  ...품목별매출.data,
                  datasets: [
                    {...품목별매출.data.datasets[0], data: response.data.resultByContractGroup.amountDatas}
                  ],
                  labels: response.data.resultByContractGroup.labels
                }
                this.dashboard.chart.장비매출.data = {
                  datasets: response?.data?.resultByEquipContract?.origins.map(d => {
                    let color
                    if (d.contractType === '서비스로봇') {
                      color = '#FFFFA0'
                    } else if (d.contractType === 'CT매매') {
                      color = '#90C5F3'
                    } else if (d.contractType === 'CADCAM') {
                      color = '#FFA07A'
                    } else if (d.contractType === 'CADCAM(IOS)') {
                      color = '#90EE90'
                    } else if (d.contractType === 'UnitChair') {
                      color = '#FFA0B5'
                    }
                    return {
                      type: 'bar',
                      label: d.contractType,
                      stack: 'combined',
                      data: [d.total],
                      backgroundColor: color
                    }
                  }),
                  labels: ['장비']
                }
                this.dashboard.chart.일별실적.data = {
                  ...일별실적.data,
                  datasets: [
                    {...일별실적.data.datasets[0], data: response.data.dailyContractTrend.amountDatas},
                    {...일별실적.data.datasets[1], data: response.data.dailyContractTrend.countDatas}
                  ],
                  labels: response.data.dailyContractTrend.labels
                }
                this.dashboard.chart.지점별실적.data = {
                  ...지점별실적.data,
                  datasets: [
                    {...지점별실적.data.datasets[0], data: response.data.deptContractTrend.amountDatas},
                    {...지점별실적.data.datasets[1], data: response.data.deptContractTrend.countDatas}
                  ],
                  labels: response.data.deptContractTrend.labels
                }
                logging().exceptProd('dashboard==>', this.dashboard)
              }, (error) => {
                console.error(error)
              })
        }
      }
    },
    api() {
      return contractApi(this.$apiInstance, this.$store)
    },
    handleYearChange(value) {
      this.selectedYear = value;
      this.uiHandler.getDashboardData();
    },
  }
}
</script>
